import {pxToRem} from '../../../utills/pxToRem'
import {fonts} from '../../foundations/fonts'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        stackContainer: {
            whiteSpace: 'nowrap',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            paddingRight: [pxToRem(0), pxToRem(0), pxToRem(30), pxToRem(70)]
        },
        popoverContent: {
            marginLeft: 'auto',
            marginRight: 'auto',
            border: 0,
            width: '100%',
            maxWidth: pxToRem(1400),
            margin: '0 auto',
            position: 'absolute',
            borderRadius: '0',
            boxShadow: `${pxToRem(1)} ${pxToRem(1)} ${pxToRem(5)} ${pxToRem(2)} #bebebd`,
            left: '50%',
            top: pxToRem(4),
            transform: 'translateX(-50%) !important' // important is required to override the chakra-ui transform
        },
        popoverBody: {
            boxShadow: 'xl',
            padding: pxToRem(10),
            zIndex: 1,
            display: 'flex',
            justifyContent: 'space-between'
        },
        popoverContainer: {
            paddingLeft: [pxToRem(20), pxToRem(20), pxToRem(8), pxToRem(8)],
            paddingRight: [pxToRem(10), pxToRem(10), pxToRem(8), pxToRem(8)],
            paddingTop: [pxToRem(10), pxToRem(10), pxToRem(0), pxToRem(0)],
            paddingBottom: [0, 0, 0, 0]
        },
        overflow: {
            height: [pxToRem(400), pxToRem(400), '100%', '100%'],
            overflowX: ['auto', 'auto', 'unset', 'unset']
        },
        listMenuTriggerContainer: {
            display: 'flex',
            alignItems: 'center',
            marginTop: [0, 0, 2, 2],
            marginBottom: [0, 0, 3, 3]
        },
        listMenuTriggerLink: {
            fontFamily: fonts.primary,
            display: 'block',
            flexGrow: 1,
            whiteSpace: 'nowrap',
            position: 'relative',
            paddingTop: [2, 2, 5, 5],
            paddingRight: pxToRem(1),
            paddingBottom: [2, 2, 2, 2],
            paddingLeft: pxToRem(1),
            fontSize: [pxToRem(8), pxToRem(8), pxToRem(8), pxToRem(14)],
            fontWeight: '600',
            lineHeight: '100%',
            textTransform: 'uppercase',
            letterSpacing: pxToRem(3),
            color: 'white',
            _hover: {
                textDecoration: 'none',
                color: 'red.cvs'
            }
        },
        listMenuTriggerLinkActive: {
            textDecoration: 'none',
            _before: {
                position: 'absolute',
                backgroundColor: 'red.cvs',
                content: 'attr(name)',
                height: '1px',
                width: '100%',
                color: 'transparent',
                bottom: '0px'
            }
        },
        listMenuTriggerlessLinkActive: {
            textDecoration: 'none',
            _before: {
                position: 'absolute',
                backgroundColor: 'red.cvs',
                content: 'attr(name)',
                height: '2px',
                width: '-webkit-fill-available',
                color: 'transparent',
                bottom: '0px'
            }
        },
        listMenuTriggerLinkIcon: {
            marginTop: 3,
            marginRight: 3,
            marginBottom: 2,
            marginLeft: 0,
            _hover: {
                textDecoration: 'none'
            }
        },
        menuContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
            height: '390px',
            overflowX: 'auto',
            width: '80%',
            paddingRight: pxToRem(60)
        },
        imageContainer: {
            display: 'flex',
            width: '20%',
            paddingRight: pxToRem(10),
            paddingBottom: pxToRem(5),
            justifyContent: 'flex-end'
        }
    },
    parts: [
        'stackContainer',
        'popoverContent',
        'popoverContainer',
        'overflow',
        'listMenuTriggerContainer',
        'listMenuTriggerLink',
        'listMenuTriggerLinkActive',
        'listMenuTriggerIcon',
        'menuContainer',
        'imageContainer'
    ]
}
